import { fetchRegion } from '@/api';
import { store } from '@/main';
import { SSRContext } from '@/types/ssr-context';

export const getUserCountryCode = async (ssrContext: SSRContext) => {
  try {
    if (process && process.server && ssrContext) {
      const userIp =
        ssrContext?.req?.headers['x-forwarded-for']?.split(',')[0] ||
        ssrContext?.req?.connection?.remoteAddress ||
        ssrContext?.req?.socket?.remoteAddress ||
        ssrContext?.req?.connection?.socket?.remoteAddress ||
        null;

      const response = await fetchRegion(userIp);
      const countryCode = (response.data.country_code || '').toLowerCase();

      return countryCode;
    } else {
      return store.getters.getCountryCode;
    }
  } catch (e) {
    console.error(e);
  }
};
